import { useSelector } from 'react-redux';
import { remoteConfigSelector } from 'redux/modules/settings/remoteConfig/selectors';
import { isNewHeaderOn } from 'utils/killswitch';

const useNewTheme = () => {
	const remoteConfig = useSelector(remoteConfigSelector);
	const isNewHeaderVisible = isNewHeaderOn(remoteConfig);
	return isNewHeaderVisible;
};

export default useNewTheme;
